import * as yup from 'yup';

const CheckoutCodeFieldValidationSchema = yup.object().shape({
  code: yup.string().required(null),
});

export default CheckoutCodeFieldValidationSchema;
